<!-- <p>home-property-details works!</p> -->

<div class="container-fluid p-0" id="dashboard">
  <div class="">
    <div class="fullHeight">
      <div class="px-0 fullHeight">
        <div class="w-100">
          <section class="col-sm-12 pt-4">
            <div>
              <div class="m-auto">
                <div class="wrap_body profileTabModule">
                  <mat-tab-group [(selectedIndex)]="selected" animationDuration="0ms">
                    <mat-tab label="Features">
                      <div class="tab-body mt-0 property-features">
                        <app-property-features [resetPanels]="resetFeatures"></app-property-features>
                      </div>
                    </mat-tab>
                    <mat-tab label="Photos">
                      <app-multiple-file-upload
                        [inputType]="'image'"
                        [featureType]="'myHome'"
                      ></app-multiple-file-upload>
                    </mat-tab>
                    <mat-tab label="Floor Plans">
                      <div class="tab-body">
                        <app-multiple-file-upload
                          [inputType]="'floor'"
                          [featureType]="'myHome'"
                        ></app-multiple-file-upload>
                      </div>
                    </mat-tab>
                    <mat-tab label="Documents">
                      <app-multiple-file-upload
                        [inputType]="'document'"
                        [featureType]="'myHome'"
                      ></app-multiple-file-upload>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
